export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00723.a2670f06.png";